import { useTranslation } from "react-i18next";

import { ModalOverlay, ModalHeader, ModalBody } from "@/components/UI/ModalOverlay";

import { WorkflowSettings } from "./WorkflowSettings";

interface ChatSettingsModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ChatSettingsModal({ isOpen, onOpenChange }: ChatSettingsModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <ModalOverlay isOpen={isOpen} size="4xl" onOpenChange={onOpenChange}>
      <ModalHeader className="flex flex-col gap-1">{t("Configuration")}</ModalHeader>
      <ModalBody>
        <div className="flex flex-col gap-4">
          {/* <ChatMetrics tokenUsage={tokenUsage} /> */}
          <WorkflowSettings isOpen={isOpen} />
          {/* <Speech /> */}
        </div>
      </ModalBody>
    </ModalOverlay>
  );
}
